var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"cursor-pointer",attrs:{"target":"_blank","href":_vm.iosAppLink}},[_c('img',{staticStyle:{"height":"42px"},attrs:{"alt":"Download in App Store","src":require("@/assets/icons/downloadButtons/appStores/appStore.svg")}})])}
var staticRenderFns = []

export { render, staticRenderFns }